var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_5933)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_850_5933",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_850_5933)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_850_5933",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_850_5933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7718 4.25334C7.61181 4.56834 3.43848 7.43501 3.43848 14.395C3.43847 14.519 3.48508 14.6385 3.56906 14.7297C3.65303 14.8209 3.76824 14.8773 3.89181 14.8875H3.93264C4.05003 14.8872 4.16347 14.8451 4.25265 14.7687C4.34182 14.6924 4.4009 14.5868 4.41931 14.4708C4.77598 12.3875 5.66181 9.66084 10.7743 9.44834V12.115C10.7745 12.2057 10.7996 12.2945 10.8469 12.3719C10.8941 12.4493 10.9618 12.5121 11.0424 12.5536C11.1231 12.5951 11.2135 12.6136 11.304 12.607C11.3944 12.6005 11.4813 12.5693 11.5551 12.5167L18.9618 7.22584C19.0258 7.18012 19.078 7.11978 19.1139 7.04985C19.1499 6.97992 19.1687 6.90241 19.1687 6.82376C19.1687 6.74511 19.1499 6.6676 19.1139 6.59766C19.078 6.52773 19.0258 6.4674 18.9618 6.42167L11.5526 1.14084C11.4788 1.08825 11.3919 1.05698 11.3015 1.05047C11.211 1.04396 11.1206 1.06245 11.0399 1.10393C10.9593 1.1454 10.8916 1.20826 10.8444 1.28561C10.7971 1.36297 10.772 1.45184 10.7718 1.54251V4.25334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9468 13.0775C11.7718 13.2025 11.5658 13.2768 11.3514 13.2925C11.1369 13.3082 10.9223 13.2645 10.731 13.1663C10.5397 13.0681 10.3791 12.9192 10.2668 12.7358C10.1545 12.5524 10.0948 12.3417 10.0943 12.1267V10.1792C6.31266 10.5458 5.44266 12.5058 5.086 14.5883C5.0414 14.8623 4.90061 15.1113 4.68893 15.2908C4.47724 15.4702 4.20851 15.5683 3.931 15.5675H3.8335C3.54123 15.5418 3.26907 15.4079 3.07025 15.1922C2.87144 14.9764 2.76027 14.6942 2.7585 14.4008C2.63046 11.4953 3.57477 8.64395 5.41183 6.38917C6.19614 5.50125 7.15383 4.78319 8.226 4.27917H2.18516C1.8274 4.27917 1.48423 4.42101 1.23086 4.67359C0.977493 4.92618 0.834599 5.26891 0.833496 5.62667V17.6033C0.833496 17.9618 0.975903 18.3056 1.22939 18.5591C1.48288 18.8126 1.82668 18.955 2.18516 18.955H14.1668C14.5253 18.955 14.8691 18.8126 15.1226 18.5591C15.3761 18.3056 15.5185 17.9618 15.5185 17.6033V10.5292L11.9468 13.0775Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_5933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileShare);
export default __webpack_public_path__ + "static/media/icon-profile-share.91558706408faebd36ba216a6cb3509f.svg";
export { ForwardRef as ReactComponent };